import { render } from "./PagesDropdown.vue?vue&type=template&id=14f5de63"
import script from "./PagesDropdown.vue?vue&type=script&lang=js"
export * from "./PagesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__